import React from 'react';
import { Icon } from './Icon.js';
export const IconPen = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M7.99998 21L21.5 7.49999L16.5 2.50005L2.99998 16L2.99999 21L7.99998 21Z", stroke: "currentColor", strokeWidth: "2", strokeMiterlimit: "10", strokeLinecap: "square", fill: "none" })));
};
//# sourceMappingURL=IconPen.js.map